import { render, staticRenderFns } from "./ZoneLmsButton.vue?vue&type=template&id=306217e8&scoped=true&lang=pug"
import script from "./ZoneLmsButton.vue?vue&type=script&lang=js"
export * from "./ZoneLmsButton.vue?vue&type=script&lang=js"
import style0 from "./ZoneLmsButton.vue?vue&type=style&index=0&id=306217e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306217e8",
  null
  
)

export default component.exports